import { CustomThemeProvider } from "./themes/CustomThemeProvider";
import {
  protectOrgTheme,
  theme_light,
  theme_dark,
  theme_green,
} from "./themes/ProtectOrgTheme";
import "reflect-metadata";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ConfigProvider } from "./configContext";
import { Routes, Route } from "react-router-dom";
import { RequireAuth } from "./features/Auth/RequireAuth";
import { LoginPage } from "./features/Auth/LoginPage";

import * as Pages from "./features";

function App() {
  return (
    <ConfigProvider>
      <CustomThemeProvider
        baseTheme={protectOrgTheme}
        defaultThemeName={"light"}
        palettes={[
          { name: "light", palette: theme_light },
          { name: "dark", palette: theme_dark },
          { name: "green", palette: theme_green },
        ]}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div className="wrapper">
              <Routes>
                <Route path="/eula" element={<Pages.EndUserLicenseAgreementPage />} />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element = {<RequireAuth roles={[]}><Pages.HomeDashboard /></RequireAuth>} />

                {/* Sign Up */}
                <Route path="/signup" element={<Pages.SignupPage />}/>
                <Route path="/confirminvite" element={<Pages.SignupConfirmInvitePage />}/>

                <Route path="/alerts" element = {<RequireAuth roles={['Alerts Viewer', 'Company Admin']}><Pages.AlertsDashboardPage /></RequireAuth> } />
                <Route path="/home" element = {<RequireAuth roles={['Client', 'Company Admin']}><Pages.HomeDashboard /></RequireAuth> } />
                <Route path="/account" element = {<RequireAuth roles={['Products Admin', 'Company Admin']}><Pages.StripeDashboard /></RequireAuth> } />
                <Route path="/alerts/:deviceId" element = {<RequireAuth roles={[]}><Pages.AlertsDashboardPage /></RequireAuth> } />
                <Route path="/new-alerts/:deviceId?" element = {<RequireAuth roles={[]}><Pages.NewAlertsDashboard /></RequireAuth> } />
                <Route path="/alert/:id" element = {<RequireAuth roles={[]}><Pages.ViewAlertPage /></RequireAuth> } />
                <Route path="/charts" element = {<RequireAuth roles={['Charts Viewer', 'Company Admin']}><Pages.ChartsDashboardPage /></RequireAuth> } />
                <Route path="/livemap" element = {<RequireAuth roles={['Map Admin', 'Company Admin']}><Pages.LiveMap /></RequireAuth> } />
                <Route path="/devices" element = {<RequireAuth roles={['Devices User', 'Company Admin']}><Pages.DevicesDashboardPage /></RequireAuth> } />
                <Route path="/device/:id/:group" element = {<RequireAuth roles={[]}><Pages.ViewDevicePage /></RequireAuth> } />
                <Route path="/changemanagement/create/:ticketId" element = {<RequireAuth roles={[]}><Pages.CreateChangeManagementItemPage /></RequireAuth> } />
                <Route path="/changemanagement/create" element = {<RequireAuth roles={['Client', 'Company Admin']}><Pages.CreateChangeManagementItemPage /></RequireAuth> } />
                <Route path="/changemanagement/" element = {<RequireAuth roles={['Client', 'Company Admin']}><Pages.ChangeManagementDashboardPage /></RequireAuth> } />
                <Route path="/changemanagement/:id" element = {<RequireAuth roles={[]}><Pages.ViewChangeManagementItemPage /></RequireAuth> } />
                <Route path="/tickets" element = {<RequireAuth roles={['End User', 'Company Admin']}><Pages.TicketsDashboardPage /></RequireAuth> } />
                <Route path="/ticket/:id" element = {<RequireAuth roles={[]}><Pages.ViewTicketPage /></RequireAuth> } />
                <Route path="/user/:id" element = {<RequireAuth roles={[]}><Pages.ViewUserProfilePage /></RequireAuth> } />
                <Route path="/settings" element = {<RequireAuth roles={['End User', 'Settings Administrator', 'Company Admin']}><Pages.SettingsDashboardPage /></RequireAuth> } />
                <Route path="/compliance" element = {<RequireAuth roles={[]}><Pages.ComplianceDashboard /></RequireAuth> } />
                <Route path="/users" element = {<RequireAuth roles={['Company Admin']}><Pages.UsersDashboard /></RequireAuth> } />
                <Route path="/runasaccounts" element = {<RequireAuth roles={['RunAs Administrator']}><Pages.RunAsAccountsDashboardPage /></RequireAuth> } />
                <Route path="/investigate/:id" element = {<RequireAuth roles={[]}><Pages.InvestigateAlertDashboardPage /></RequireAuth> } />
                <Route path="/investigate/:id/:group" element = {<RequireAuth roles={[]}><Pages.InvestigateDeviceDashboardPage /></RequireAuth> } />
                <Route path="/darkweb" element = {<RequireAuth roles={['Dark Web User', 'Company Admin']}><Pages.FlareDashboardPage /></RequireAuth> } />
                <Route path="/investigatefirewall" element = {<RequireAuth roles={['Firewall Admin', 'Company Admin']}><Pages.InvestigateFirewallDashboardPage /></RequireAuth> } />
                <Route path="/reports" element = {<RequireAuth roles={['Reports Viewer', 'Company Admin']}><Pages.ReportsDashboardPage /></RequireAuth> } />
              </Routes>
          </div>
        </LocalizationProvider>
      </CustomThemeProvider>
    </ConfigProvider>
    
  );
}

export default App;
